import { TypeBoundAxiosInstance } from '@m43/shared';
import { ConnectionStatusReportView, MetricsResource } from '@mark43/cad-api';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { convertFrontendConnectionStatusDtoToCombinedConnectionStatusReport } from './converters';

const ONE_MINUTE = 1000 * 60;

export async function initiateReportConnectionStatusLoop(apiClient: TypeBoundAxiosInstance) {
    let dtos: ConnectionStatusReportView[] | undefined;
    if (
        electronBridge &&
        electronBridge.args['--workspace-window-type'] === 'EVENT_V2' &&
        !window.Cypress
    ) {
        if ('getConnectionStatusDtos' in electronBridge && electronBridge.getConnectionStatusDtos) {
            const oldDtos = await electronBridge.getConnectionStatusDtos();
            dtos = oldDtos.map(convertFrontendConnectionStatusDtoToCombinedConnectionStatusReport);
        }
    }
    if (dtos && dtos.length > 0) {
        await apiClient
            .request<MetricsResource.PostCombinedConnectionStatusReports>({
                method: 'POST',
                url: 'metrics/combined_connection_status_reports/',
                data: { connectionStatusReportViews: dtos },
            })
            .then(() => {
                if (dtos) {
                    const dtoIds = dtos.map((dto) => dto.uuid);
                    if (
                        electronBridge &&
                        'deleteConnectionStatusDtos' in electronBridge &&
                        electronBridge.deleteConnectionStatusDtos
                    ) {
                        electronBridge.deleteConnectionStatusDtos(dtoIds);
                    }
                }
            });
    }
    setTimeout(() => {
        initiateReportConnectionStatusLoop(apiClient);
    }, ONE_MINUTE);
}
